import { ActionId } from 'admin/actions/Actions';

export const JOURNEY_PAGE_PROMISE_AREA = 'journey-data-response-promise';

export const INSIGHTS_USER_AUTH = {
    actions: [ActionId.AnalyticInsights.View],
};

export const JOURNEY_INSIGHTS_USER_AUTH = {
    actions: [ActionId.AnalyticJourneyInsights.View, ActionId.AnalyticWordCloud.View, ActionId.AnalyticTornado.View],
};
